
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.945 7.453v3.922H.602V4.477c0-2.74 1.164-4.11 3.492-4.11.979 0 1.737.323 2.273.969.542.64.813 1.539.813 2.695 0 1.328-.295 2.344-.883 3.047-.589.698-1.388 1.047-2.399 1.047-.765 0-1.416-.224-1.953-.672zm0-2.797v1.282c0 .453.177.825.532 1.117.354.286.776.43 1.265.43 1.313 0 1.969-1.034 1.969-3.102 0-2.26-.589-3.39-1.766-3.39-1.333 0-2 1.22-2 3.663z","fill":"currentColor"}})])
          )
        }
      }
    